import React from "react";
import { useTranslation } from "react-i18next";
import searchIcon from '../../../../assets/icons/search.svg';

const GREEN_FILTER = '[filter:brightness(0)_saturate(100%)_invert(18%)_sepia(70%)_saturate(6415%)_hue-rotate(142deg)_brightness(93%)_contrast(84%)]';

function SearchStart() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center py-10 px-6 gap-3">
            <div className="w-14 h-14 rounded-2xl bg-[#e8f5ea] flex items-center justify-center">
                <img src={searchIcon} alt="" width={26} height={26} className={GREEN_FILTER} />
            </div>
            <h3 className="m-0 text-[16px] font-bold text-[#222222]">
                {t('start_search')}
            </h3>
            <p className="m-0 text-[13px] text-[#939393] text-center max-w-[280px] leading-relaxed">
                {t('enter_request')}
            </p>
        </div>
    );
}

export default SearchStart;
